export default __webpack_public_path__ + "static/media/oldportfolio.5f4be8cd.png";